import filter from 'lodash/filter';

export const getSelectedRows = rows => {

    const filteredInMemoryRows = filter(rows, {selected: true});

    return filteredInMemoryRows.map(row => row.data);

};



// WEBPACK FOOTER //
// ./src/reports/shared/services/get-selected-rows-from-in-memory-rows.js